const WaIcon = ({ className = "w-5 h-5" }) => (
    <svg
        viewBox="0 0 32 32"
        className={className}
        fill="currentColor"
        aria-hidden="true"
    >
        <path d="M19.11 17.55c-.29-.14-1.7-.84-1.96-.94-.26-.1-.46-.14-.65.15-.19.29-.74.94-.91 1.13-.17.19-.33.22-.62.07-.29-.14-1.22-.45-2.32-1.43-.86-.76-1.44-1.71-1.61-2-.17-.29-.02-.45.13-.6.13-.13.29-.33.44-.5.15-.17.19-.29.29-.48.1-.19.05-.36-.02-.5-.07-.14-.65-1.57-.9-2.15-.24-.57-.48-.49-.65-.5-.17-.01-.36-.01-.55-.01-.19 0-.5.07-.76.36-.26.29-1 .98-1 2.38 0 1.4 1.02 2.75 1.16 2.94.14.19 2 3.07 4.86 4.19.68.29 1.21.46 1.62.59.68.22 1.29.19 1.78.12.54-.08 1.7-.7 1.94-1.37.24-.67.24-1.24.17-1.37-.07-.13-.26-.22-.55-.36zM16 6C10.48 6 6 10.48 6 16c0 1.77.47 3.43 1.28 4.86L6 26l5.3-1.39A9.96 9.96 0 0 0 16 26c5.52 0 10-4.48 10-10S21.52 6 16 6z" />
    </svg>
);

export default WaIcon;
